import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigService } from 'src/app/shared/config';

// A kampanje must target at least one category or one product.
const categoryOrProduct = (group: AbstractControl): ValidationErrors | null => {
  const categories = group.get('categories')?.value || [];
  const products = group.get('products')?.value || [];
  return categories.length || products.length ? null : { noTarget: true };
};

@Component({
  selector: 'app-kampanje-category-form',
  templateUrl: './kampanje-category-form.component.html',
  styleUrls: ['./kampanje-category-form.component.css'],
})
export class KampanjeCategoryFormComponent implements OnInit {
  subscriptionForm: FormGroup;
  weekDays = [{ name: 'Monday', index: 1 }, { name: 'Tuesday', index: 2 }, { name: 'Wednesday', index: 3 }, { name: 'Thursday', index: 4 }, { name: 'Friday', index: 5 }, { name: 'Saturday', index: 6 }, { name: 'Sunday', index: 7 }];
  isEditMode = false;
  systems = [];
  categories = [];
  products = [];
  @ViewChild('mySelect') mySelect;
  @ViewChild('productSelect') productSelect;
  // Filtered lists that will be shown in the selects
  filteredSystems: any[] = [];
  filteredProducts: any[] = [];
  // Names of the chosen products, kept in a field (not a getter) for *ngFor.
  selectedProductNames: string[] = [];

  constructor(
    private fb: FormBuilder,
    private config: ConfigService,
    public dialogRef: MatDialogRef<KampanjeCategoryFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.systems = data.systems;
    this.categories = data.categories;
    this.products = data.products || [];
    this.isEditMode = !!data.eventData;
    this.subscriptionForm = this.fb.group({
      name: ['', Validators.required],
      systems: [[], Validators.required],
      categories: [[]],
      products: [[]],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      active: [Boolean, Validators.required],
      percentage: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
      // Edit: one day (one doc per day). Create: several days, one doc is saved per day.
      selectedDays: [this.isEditMode ? '' : [], Validators.required]
    }, { validators: categoryOrProduct });

    this.subscriptionForm.get('products').valueChanges.subscribe(ids => {
      this.selectedProductNames = (ids || []).map(id => this.products.find(p => p.id === id)?.name || id);
    });

    if (data.eventData) {
      const subscription = data.eventData;
      this.subscriptionForm.patchValue({
        companyId: this.config.getCompanyId(),
        systems: subscription.systems,
        name: subscription.name,
        categories: subscription.categories || [],
        products: subscription.products || [],
        active: subscription.active.toString(),
        startTime: subscription.startTime, // Convert Unix time to HH:mm
        endTime: subscription.endTime, // Convert Unix time to HH:mm
        percentage: subscription.percentage,
        selectedDays: subscription.selectedDays
      });
    }
  }
  ngOnInit(): void {
    this.filteredSystems = [...this.systems];
    this.filteredProducts = [...this.products];
  }


  filterSystems(search: string): void {
    if (!search) {
      this.filteredSystems = [...this.systems];
      return;
    }
    this.mySelect.open();
    const lowerSearch = search.toLowerCase();
    this.filteredSystems = this.systems.filter(system =>
      system.systemName.toLowerCase().includes(lowerSearch)
    );
  }

  selectAllSystems(): void {
    this.subscriptionForm.get('systems').setValue(this.systems.map(s => s.systemId));
  }

  clearSystems(): void {
    this.subscriptionForm.get('systems').setValue([]);
  }

  filterProducts(search: string): void {
    if (!search) {
      this.filteredProducts = [...this.products];
      return;
    }
    this.productSelect.open();
    const lowerSearch = search.toLowerCase();
    this.filteredProducts = this.products.filter(product =>
      (product.name || '').toLowerCase().includes(lowerSearch) ||
      String(product.productNumber || '').toLowerCase().includes(lowerSearch)
    );
  }

  selectAllDays(): void {
    this.subscriptionForm.get('selectedDays').setValue(this.weekDays.map(d => d.index));
  }


  onSubmit() {
    if (this.subscriptionForm.valid) {
      this.dialogRef.close(this.subscriptionForm.value);
    }
  }


}
